import {useContext} from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import AppContext from "../AppContext";
import RenewSubscription from "../components/RenewSubscription";

export default function RequireSubscription() {
    const app = useContext(AppContext)

    return <div id="page-require-subscription" className={"page " + (app.ui.isDrawerOpen ? 'menu-shown' : '')}>
        <Sidebar />
        <div className="page-inner">
            <Header />
            <RenewSubscription />
        </div>
    </div>
}